import React from "react";
import styled from "styled-components";
import {device} from "../../assets/styles/media.js";

const TableWrapper = styled.div`
    width: 100%;
    margin: 0 auto;
    box-sizing: border-box;
`;

const Table = styled.table`
    width: 550px;
    border-collapse: collapse;
    text-align: center;
    table-layout: fixed;
    border-spacing: 0;

    ${device.mobile} {
        max-width: 100vw;
        width: 100%;
        height: 300px;
    }
`;

const Caption = styled.caption`
    position: absolute;
    font-weight: 500;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
`;

const Col = styled.col`
    width: 50%;
`;

const Thead = styled.thead`
    display: table-header-group;
    vertical-align: middle;
    unicode-bidi: isolate;
    border-color: inherit;
`;

const Tr = styled.tr`
    
    &:nth-child(2n){
        background-color: #fbfbfb;
    }
    th:not(:first-child),
    td:not(:first-child) {
        border-left: 1px solid #d6d6d6;;
    }
`;

const Th = styled.th`
    padding: 12px 0;
    font-size: 16px;
    line-height: 24px;
    border-bottom: 1px solid #ddd;
    border-top: 1px solid #d6d6d6;
    background-color: #fbfbfb;
    color: #222222;
    ${device.mobile} {
        font-size: 14px;
    }
`;

const Td = styled.td`
    padding: 12px;
    text-align: center;
    border-bottom: 1px solid #ddd;
    font-size: 16px;
    ${device.mobile} {
        font-size: 14px;
    }
`;

const ShuttlePlace = styled.div`
    margin-top: 20px;
    ${device.tablet} {
        zoom: 1.2;
    }
`;

const ShuttleTitle = styled.strong`
    color: #362579;
    font-size: 17px;
    font-weight: 800;

    ${device.mobile} {
        font-size: 14px;
        font-weight: 700;
    }
`;

const ShuttleBox = styled.ul`
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    margin-top: 10px;
`;

const ShuttleItem = styled.li`
    flex-direction: column;
    gap: 6px;
    margin-bottom: 4px;

    ${device.mobile} {
        flex-direction: column;
    }
`;

const YellowBox = styled.span`
    border-radius: 50px;
    display: inline-block;
    padding: 3px 12px;
    font-size: 14px;
    background-color: #f5ab2b;
    color: #fff;
    font-weight: 500;
    letter-spacing: -0.2px;

    ${device.tablet} {
        margin-bottom: 5px;
        display: block;
    }

    ${device.mobile} {
        margin-bottom: 5px;
        display: block;
        font-size: 13px;
        font-weight: 500;
    }
`;

const ShuttleText = styled.span`
    font-size: 15px;
    margin: 0 40px 0 8px;
    color: #414141;
    font-weight: 500;
    ${device.mobile}{
        font-size: 13px;
    }
`;

const ShuttleBusModal = () => {
    const times = [
        ["10:30", "11:10"],
        ["11:00", "11:40"],
        ["11:30", "12:10"],
        ["12:00", "12:40"],
        ["13:00", "13:40"],
        ["13:30", "14:10"],
        ["14:00", "14:40"],
        ["14:30", "15:10"],
        ["15:00", "15:40"],
        ["15:30", "16:10"],
        ["16:00", "16:40"],
        ["16:30", "17:10"],
        ["17:00", "17:40"],

    ];
    return (
        <>
            <TableWrapper>
                <Table>
                    <Caption>무료 셔틀 운행 시간</Caption>
                    <colgroup>
                        <Col/>
                        <Col/>
                    </colgroup>
                    <Thead>
                        <Tr>
                            <Th colSpan="2">셔틀버스 운행 시간표</Th>
                        </Tr>
                        <Tr>
                            <Th>박물관 → 네이처풀&큰/작은운동장</Th>
                            <Th>네이처풀&큰/작은운동장 → 박물관</Th>
                        </Tr>
                    </Thead>
                    <tbody>
                    {times.map(([from, to], i) => (
                        <Tr key={i}>
                            <Td>{from}</Td>
                            <Td>{to}</Td>
                        </Tr>
                    ))}
                    </tbody>
                </Table>
            </TableWrapper>
            <ShuttlePlace>
                <ShuttleTitle>내부 셔틀버스 승차장소</ShuttleTitle>
                <ShuttleBox>
                    <ShuttleItem>
                        <YellowBox>박물관 → 네이처풀&큰/작은운동장</YellowBox>
                        <ShuttleText>박물관 앞 주차장 내 승강장</ShuttleText>
                    </ShuttleItem>
                </ShuttleBox>
                <ShuttleBox>
                    <ShuttleItem>
                        <YellowBox>네이처풀&큰/작은운동장 → 박물관</YellowBox>
                        <ShuttleText>네이처풀 승강장</ShuttleText>
                    </ShuttleItem>
                </ShuttleBox>
            </ShuttlePlace>
        </>
    );
};

export default ShuttleBusModal;
